import React from 'react';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section className="bg-leaf-soft py-5 sm:py-7" data-id="element-17" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-18" data-mp="pjg7a5ljxg31">
        <h2 className="text-center text-2xl leading-none text-forest sm:text-4xl" data-id="element-19" data-mp="avlb2f8c4tl7">
          5 premium bonuses <span className="text-leaf" data-id="element-20" data-mp="ftmresedmesz">included</span>
        </h2>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-21" data-mp="frtkrd3rjukz">
          {bonuses.map((bonus, i) => <article key={bonus.label} className={`rounded-lg border-2 border-forest bg-white p-3 sm:p-4 ${i === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-22" data-mp="5w0do98tctal" data-mpi={i}>
              <p className="w-fit rounded bg-gold px-2 py-0.5 font-display text-xs font-extrabold uppercase tracking-wide text-forest" data-id="element-23" data-mp="3szwqt6vas43s">
                {bonus.label}
              </p>
              <h3 className="mt-1 text-sm leading-tight text-forest sm:text-base" data-id="element-24" data-mp="1r9v0lcobcodm">
                {bonus.title}
              </h3>
              <p className="mt-1 text-sm leading-snug text-ink" data-id="element-25" data-mp="3id52z1tcov8o">{bonus.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}